import { createSelector } from '@ngrx/store';
import { selectDashboardState } from '../dashboard.selectors';
import { FavoritesState } from './favorites.state';
import { DashboardState } from '../dashboard.state';

export const selectFavoritesState = createSelector(
  selectDashboardState,
  (dashboardState: DashboardState) => {
    return dashboardState.favorites;
  }
);

export const selectTotalFavorites = createSelector(
  selectFavoritesState,
  (favoritesState: FavoritesState) => favoritesState.total
);

export const selectLoadingFavorites = createSelector(
  selectFavoritesState,
  (favoritesState: FavoritesState) => favoritesState.loading
);

export const selectFavorites = (props: { limit?: number }) => {
  return createSelector(
    selectFavoritesState,
    (favoritesState: FavoritesState) => {
      if (props.limit) {
        return favoritesState.favorites.slice(0, props.limit);
      }
      return favoritesState.favorites;
    }
  );
};
